import { Fetcher } from 'swr'
import { MutationFetcher } from 'swr/mutation'
import { client } from '~/api/client'
import {
  createCoordinateLike,
  deleteCoordinateLike,
  getMemberCoordinateCurrentMemberStatesV1,
} from '~/api/gen'
import { useLike } from '~/hooks/useLike'
import { assertSuccess } from '~/lib/assertSuccess'

const key = 'memberCoordinateCurrentMemberStates'
type Key = [typeof key, number[], string | null]
const getLikeId: Fetcher<number | undefined, Key> = async ([
  _,
  coordinateIds,
  accessToken,
]) => {
  if (!accessToken) return
  const res = await getMemberCoordinateCurrentMemberStatesV1(
    client,
    { parameter: { 'coordinate_ids[]': coordinateIds } },
    { token: accessToken }
  )
  assertSuccess(res)
  return res.data.coordinate_current_member_states[0]?.like?.id
}

const createLike: MutationFetcher<
  number | undefined,
  Key,
  { accessToken: string; id: number }
> = async (_, { arg: { accessToken, id } }) => {
  if (!accessToken) return
  const res = await createCoordinateLike(
    client,
    { parameter: { coordinate_id: id.toString() } },
    { token: accessToken }
  )
  assertSuccess(res)
  return res.data.id
}

const deleteLike: MutationFetcher<
  void,
  Key,
  { accessToken: string; id: number; likeId: number }
> = async (_, { arg: { accessToken, id, likeId } }) => {
  if (!accessToken) return
  const res = await deleteCoordinateLike(
    client,
    { parameter: { coordinate_id: id.toString(), coordinate_like_id: likeId } },
    { token: accessToken }
  )
  assertSuccess(res)
}

export const useCoordinateLike = (
  coordinateId: number,
  initialLikeCount = 0
) => {
  return useLike<Key>({
    key,
    id: coordinateId,
    getLikeId,
    createLike,
    deleteLike,
    initialLikeCount,
  })
}
